module.exports = __webpack_public_path__ + "43270ac15240cb5d29e43ebd8d4ab735.pdf";